<template>
  <footer class="bg-neutrals-surface py-12">
    <div class="container mx-auto px-6 max-w-7xl">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div>
          <h4 class="text-xl font-bold mb-4 text-neutrals-text">Endereço</h4>
          <address class="not-italic text-neutrals-muted">
            <p>{{ enterprise.address }}, {{ enterprise.number }}</p>
            <p>{{ enterprise.neighborhood }}, {{ enterprise.city }} - {{ enterprise.state }}</p>
            <p>CEP: {{ enterprise.zip_code }}</p>
            <p class="mt-4">CRECI: {{ enterprise.creci }}</p>
          </address>
        </div>

        <div>
          <h4 class="text-xl font-bold mb-4 text-neutrals-text">Contato</h4>
          <ul class="text-neutrals-muted">
            <li>{{ enterprise.phone }}</li>
            <li>{{ enterprise.email }}</li>
          </ul>
        </div>

        <div>
          <h4 class="text-xl font-bold mb-4 text-neutrals-text">Navegação</h4>
          <ul class="text-neutrals-muted">
            <li>
              <router-link :to="{ name: 'HomePage', query: { op: 'sale' } }"
                :class="`text-neutrals-muted hover:text-secondary transition duration-300`">Imóveis para
                Venda</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'HomePage', query: { op: 'rent' } }"
                :class="`text-neutrals-muted hover:text-secondary transition duration-300`">Imóveis para
                Locação</router-link>
            </li>
            <!--<li><a href="#" class="hover:text-secondary">Sobre Nós</a></li>-->
          </ul>
        </div>

        <div>
          <h4 class="text-xl font-bold mb-4 text-neutrals-text">Redes Sociais</h4>
          <div class="flex space-x-4">
            <a href="https://www.facebook.com/varandaimoveisribeiraopreto" target="_blank" rel="noopener noreferrer"
              class="text-neutrals-muted hover:text-secondary transition duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                <path
                  d="M22.675 0h-21.35C.593 0 0 .593 0 1.325v21.351C0 23.406.593 24 1.325 24h11.495v-9.294H9.691v-3.622h3.129V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.763v2.312h3.587l-.467 3.622h-3.12V24h6.116C23.407 24 24 23.406 24 22.676V1.325C24 .593 23.407 0 22.675 0z" />
              </svg>
            </a>
            <a href="https://www.instagram.com/varandaimoveis.rp" target="_blank" rel="noopener noreferrer"
              class="text-neutrals-muted hover:text-secondary transition duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                stroke-width="1.5" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M7.5 3h9A4.5 4.5 0 0 1 21 7.5v9A4.5 4.5 0 0 1 16.5 21h-9A4.5 4.5 0 0 1 3 16.5v-9A4.5 4.5 0 0 1 7.5 3z" />
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <circle cx="17.5" cy="6.5" r="0.75" fill="currentColor" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import api from '@/services/api';
import { ref, onMounted } from 'vue';

const enterprise = ref({});

onMounted(async () => {
  try {
    const response = await api.get('/enterprise');
    enterprise.value = response.data.data[0];
  } catch (error) {
    console.error('Erro ao buscar empresa:', error);
  }
});

function formatPhone(phone) {
  if (!phone) {
    return '';
  }

  const cleaned = ('' + phone).replace(/\D/g, '');

  const match11 = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
  if (match11) {
    return `(${match11[1]}) ${match11[2]}-${match11[3]}`;
  }

  const match10 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
  if (match10) {
    return `(${match10[1]}) ${match10[2]}-${match10[3]}`;
  }

  return phone;
}

</script>

<style scoped></style>